import styles from './styles.module.css'
export default function DescriptionTool({dict}) {
    const {description_ces_tool_1, description_ces_tool_2, description_ces_tool_3, description_ces_tool_4, description_ces_tool_5} = dict.discover;
    return (
        <section className={styles.container}>
            <p dangerouslySetInnerHTML={{ __html: description_ces_tool_1 }} />
            <p dangerouslySetInnerHTML={{ __html: description_ces_tool_2 }} />
            <p dangerouslySetInnerHTML={{ __html: description_ces_tool_3 }} />
            <p dangerouslySetInnerHTML={{ __html: description_ces_tool_4 }} />
            <p dangerouslySetInnerHTML={{ __html: description_ces_tool_5 }} />
        </section>
    );
}
